import { useContext, useEffect, useState } from 'react';
import { dataStore } from 'store/data';
import { appStore } from 'store/app';
import { uiStore } from 'store/ui';

const useAddToCart = () => {
  const [uiState, setUiState] = useContext(uiStore);
  const [{ locale }] = useContext(dataStore);
  const [appState] = useContext(appStore);
  const [isAddToCart, setIsAddToCart] = useState(false);

  // 日本語のサンプルデータ
  // useAddToCart: {
  //   text01: 'カートエラー'
  // }
  const { text01 } = locale.useAddToCart;

  const itemObj = {
    id: 0,
    quantity: 1,
  };

  const sizeId = appState.customData.bottle.size;

  useEffect(() => {
    if (isAddToCart) {
      // エラーをクリア
      setCartError(false);

      // ボトルの ID を初期値に
      let items = [{ ...itemObj, id: Number(appState.customData.bottle.id) }];
      // その他オプションの ID を配列に追加
      appState.customData.partsList.map((item) => {
        if (item.id) {
          items.push({ ...itemObj, id: Number(item.id) });
        }
        return item;
      });
      // 底ラバーがある場合、底ラバーのID を配列に追加
      if (appState.customData.bootsList) {
        items.push({...itemObj, id: Number(appState.customData.bootsList[0].variants[sizeId].id) });
      }

      items = items.reverse()

      const formData = { items };
      // console.log(formData);

      const addToCart = async () => {
        // ローカルテスト用
        // return await new Promise((resolve) => setTimeout(resolve, 1000));

        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        });
        const data = await res.json();
        window.location.href="/cart";
        return data;
      };

      addToCart()
        .then((data) => {
          // console.log(data);
          setIsAddToCart(false);
          // カートドロワーを表示
          if (window.ajaxCart) {
            window.ajaxCart.load();
          }

          // GA イベントトラッキング
          if (window.addToCart) {
            // その他オプションの SKU の配列
            const partsListSkus = appState.customData.partsList.map((item) => item.sku);
            // 底ラバーがある場合、底ラバーの SKU の配列
            const bootsListSkus = appState.customData.bootsList ?
                [appState.customData.bootsList[0].variants[sizeId].sku] : [];
            // ボトル、その他オプション、底ラバーの SKU をまとめる
            const skus = [appState.customData.bottle.sku, ...partsListSkus, ...bootsListSkus];

            // グローバルで定義されたトラッキング関数を実行
            // console.log('skus', skus);
            skus.forEach((sku) => window.addToCart(sku));
          }
        })
        .catch((error) => {
          // エラーメッセージをレスポンス、 theme.strings から取得
          const errorMessage = error.responseJSON
            ? error.responseJSON.description
            : window.theme
            ? window.theme.strings.cartError
            : text01;
          setCartError(true, errorMessage);
          console.error('Error:', error);
          setIsAddToCart(false);
        });
    }
    // eslint-disable-next-line
  }, [isAddToCart]);

  const addToCart = () => {
    setIsAddToCart(true);
  };

  const setCartError = (isError = false, message = '') => {
    setUiState({
      ...uiState,
      isErrorAddToCart: isError,
      errorMesageAddToCart: message,
    });
  };

  return [isAddToCart, addToCart];
};

export default useAddToCart;
